import { GET_IMPORT_LOCATIONS_PROGRESS_STATUS } from './types';

const getImportLocationProgressStatus = progressStatus => ({
  type: GET_IMPORT_LOCATIONS_PROGRESS_STATUS,
  progressStatus,
});

export default getImportLocationProgressStatus;
